import { Component, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EventEmitter } from 'protractor';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { BaseCommonComponent, BaseDataService, UserService, ModalService, NotificationService } from 'yt-ng-framework';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-comment',
  templateUrl: './comment.component.html'
})
export class CommentComponent extends BaseCommonComponent implements OnInit{

submitted = false;
  @Input() Parameters;
  nazivLabele1 = "";
  nazivLabele2 = "";
  label1Visibility : boolean = true;
  label2Visibility : boolean = true;
  naslov = "";

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService,
  ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);

  }


  ngOnInit() {

    this.baseFormGroup = new FormGroup({
     Napomena1: new FormControl(''),
     Napomena2: new FormControl(''),
    })
    // this.translateService.get([this.Parameters[0].Value], [this.Parameters[1].Value], [this.Parameters[2].Value])
    this.translateService.get([this.Parameters[0].Value, this.Parameters[1].Value, this.Parameters[2] ? this.Parameters[2].Value : ''])
    .subscribe(translate => {
        this.naslov = translate[this.Parameters[0].Value]; 
        this.nazivLabele1 = translate[this.Parameters[1].Value];    
        this.nazivLabele2 = this.Parameters[2] ? translate[this.Parameters[2].Value] : '';   
        this.label1Visibility = this.Parameters[1] ? true : false;    
        this.label2Visibility = this.Parameters[2] ? true : false;                   
               
    });

    let isAcceptParam = this.Parameters.find(p => p != null && p.Name === 'accept');
    let isAccept = false;

    if (isAcceptParam) {
      isAccept = isAcceptParam.Value === true; 
    }

 setTimeout(() => {
     if (!isAccept) {         
     this.addValidatorToFc("Napomena1",Validators.required,'required',"COMMENT.REJECT.REASON.VALIDATION.REQUIRED");
     this.addValidatorToFc("Napomena1", Validators.maxLength(500), 'maxlength', 'COMMENT.RAZLOG.VALIDATION.MAXLENGTH');
     } else {
        this.baseFormGroup.get('Napomena1').clearValidators();
      }
        this.baseFormGroup.get('Napomena1').updateValueAndValidity();
    });
  }
  
  Close(){
    this.activeModal.close();
  }

  Ok(){
    this.submitted = true;

    if (this.baseFormGroup.valid) {
      let napomena1 = this.baseFormGroup.get('Napomena1').value;
      let napomena2 = this.baseFormGroup.get('Napomena2').value;

      this.activeModal.close(napomena1 + ";" + napomena2);
    }
  }

}  
